import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@storable/canaveral-components';
import Button from '../../../../../modules/react/components/stateless/Button';
import styles from './Modal.scss';

const propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  message: PropTypes.string,
  confirmationButton: PropTypes.string,
  show: PropTypes.bool.isRequired,
  confirmed: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
};

const defaultProps = {
  title: undefined,
  name: undefined,
  message: undefined,
  confirmationButton: undefined,
  body: undefined,
  onConfirm: undefined,
};

const ActionModal = ({
  name, message, body, show, confirmed, onClose, onConfirm, title, confirmationButton,
}) => {
  const titleizedName = name ? `${name[0].toUpperCase()}${name.substring(1)}` : '';
  const modalTitle = title || `${titleizedName} Page`;
  const confirmationText = 'Congrats! Action successful.';
  const confirmationButtonText = confirmationButton || titleizedName;
  const bodyText = `Are you sure you want to ${name} this page?`;
  const modalBody = (
    typeof body === 'object'
      ? body
      : <p>{ body || bodyText }</p>
  );

  return (
    <Modal
      show={show}
      onDismiss={onClose}
      aria-labelledby="action-modal"
    >
      <Modal.Header>
        <Modal.Title id="actionModal">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.message}>
        {confirmed
          ? confirmationText
          : (
            <React.Fragment>
              {message && <p>{message}</p>}
              {modalBody}
            </React.Fragment>
          )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>
          Close
        </Button>
        {!confirmed &&
        <Button variant="danger" onClick={onConfirm}>
          {confirmationButtonText}
        </Button>
        }
      </Modal.Footer>
    </Modal>
  );
};

ActionModal.propTypes = propTypes;
ActionModal.defaultProps = defaultProps;

export default ActionModal;
